export class OptionModel {
    key: string
    value: string
    type: string
}